import { FormattedMessage, useIntl } from "react-intl";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/kit/ui/form";
import { Combobox } from "@/kit/ui/combobox";
import { useValibotFormContext } from "@/utils/validation";
import { LICENSES } from "@/utils/license";
import { Schema } from "./schema";
import DatasetVersionAuthorInput from "../DatasetVersionAuthorInput";

export default function PublishForm() {
  const intl = useIntl();
  const form = useValibotFormContext<Schema>();

  return (
    <>
      <FormField
        control={form.control}
        name="license"
        render={({ field }) => (
          <FormItem>
            <FormLabel>
              <FormattedMessage defaultMessage="License" />
            </FormLabel>

            <FormControl>
              <Combobox
                items={LICENSES.map((license) => ({
                  value: license,
                  label: license,
                }))}
                emptyMessage={intl.formatMessage({
                  defaultMessage: "No license found",
                })}
                placeholder={intl.formatMessage({
                  defaultMessage: "Add license",
                })}
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="authors"
        render={({ field }) => (
          <FormItem className="w-full">
            <FormLabel>
              <FormattedMessage defaultMessage="Authors" />
            </FormLabel>

            <FormControl>
              <DatasetVersionAuthorInput {...field} />
            </FormControl>

            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
}
